import { type App, inject } from 'vue'

const key = 'plugin.checkout.com.api'

export function provideCheckoutComApiUrl(
    app: App,
    url: string | undefined
): void {
    app.provide(key, url)
}

export function useCheckoutComApiUrl(): string | undefined {
    return inject(key) as string
}
